<template>
  <div
    id="strategy-detail"
    class="soft-gray"
    :class="$store.state.audience"
  >
    <header-section
      :trademark="trademark"
      breadcrumb=""
      :sub-header="subHeader"
      :needs-jump-button="true"
      :needs-nav-buttons="true"
    />
    <div
      id="content"
      class="outer-container"
    >
      <section
        v-if="showSummarySection"
        id="summary-section"
      >
        <summary-section />
      </section>
      <section
        v-if="showReturnsSection"
        id="returns-section"
      >
        <returns-section />
      </section>
      <section
        v-if="showRatingsSection"
        id="ratings-section"
      >
        <ratings-section />
      </section>
      <section
        v-if="showHoldingsSection"
        id="holdings-section"
      >
        <holdings-section />
      </section>
      <section
        v-if="showPricesSection"
        id="prices-section"
      >
        <prices-distributions-section />
      </section>
      <section
        v-if="showFeesSection"
        id="fees-section"
      >
        <fees-section />
      </section>
      <section
        v-if="showResourcesSection"
        id="resources-section"
      >
        <resources-section />
      </section>
    </div>
    <modals-section />
  </div>
</template>

<script>
import Header from '_components_/SectionComponents/Header';
import Summary from '_components_/SectionComponents/Summary';
import Returns from '_components_/SectionComponents/Returns';
import RatingsAndRisk from '_components_/SectionComponents/RatingsAndRisk';
import QuarterlyHoldings from '_components_/SectionComponents/Holdings';
import FeesAndExpenses from '_components_/SectionComponents/FeesAndExpenses';
import PricesAndDistributions from '_components_/SectionComponents/PricesAndDistributions';
import Resources from '_components_/SectionComponents/Resources';
import Modals from '_components_/SectionComponents/Modals';
import { mapGetters } from 'vuex';
import router from '_AFIS_/router/index';
import DownloadMixin from '_mixins_/DownloadMixin';
export default {
	name: 'DetailPage',
	components: {
		'header-section': Header,
		'summary-section': Summary,
		'returns-section': Returns,
		'ratings-section': RatingsAndRisk,
		'holdings-section': QuarterlyHoldings,
		'fees-section': FeesAndExpenses,
		'prices-distributions-section': PricesAndDistributions,
		'resources-section': Resources,
		'modals-section': Modals
	},
	mixins: [DownloadMixin],
	data() {
		return {
			trademark: 'SM',
			subHeader: 'American Funds Insurance Series - Growth-Income Fund Class 1'
		};
	},
	computed: {
		...mapGetters(['cssLoaded', 'getBreakpoint', 'activeNavTab']),
		fundSymbol() {
			return this?.getFundAttributes?.FundSymbol ?? '';
		},
		showSummarySection() {
			return (
				(!this.getBreakpoint.isSmall && !this.getBreakpoint.isMedium) ||
				this.activeNavTab === 'Summary' ||
				this.activeNavTab === 'OverView'
			);
		},
		showReturnsSection() {
			return (
				(!this.getBreakpoint.isSmall && !this.getBreakpoint.isMedium) ||
				this.activeNavTab === 'Returns'
			);
		},
		showRatingsSection() {
			return (
				(!this.getBreakpoint.isSmall && !this.getBreakpoint.isMedium) ||
				this.activeNavTab === 'Ratings & Risk' ||
				this.activeNavTab === 'Portfolio Composition'
			);
		},
		showHoldingsSection() {
			return (
				(!this.getBreakpoint.isSmall && !this.getBreakpoint.isMedium) ||
				this.activeNavTab === 'Holdings' ||
				this.activeNavTab === 'Portfolio Composition'
			);
		},
		showPricesSection() {
			return (
				(!this.getBreakpoint.isSmall && !this.getBreakpoint.isMedium) ||
				this.activeNavTab === 'Prices & Distributions'
			);
		},
		showFeesSection() {
			return (
				(!this.getBreakpoint.isSmall && !this.getBreakpoint.isMedium) ||
				this.activeNavTab === 'Fees & Expenses'
			);
		},
		showResourcesSection() {
			return (
				(!this.getBreakpoint.isSmall && !this.getBreakpoint.isMedium) ||
				this.activeNavTab === 'Resources'
			);
		}
	},
	methods: {
		navigate() {
			router.push({
				name: 'Not-Found',
				params: { unknownUrl: window.location.href }
			});
		}
	}
};
</script>

<style>
@import '~_css_/strategyDetail.css';
@import '~_css_/printToPDF.css';
@import '~_css_/list.css';
@import '~_css_/module.css';
#strategy-detail {
	position: relative;
}
/* CG-21072: Unhide the download data button and icon, since now we are re-introducing AFIS download data */
#tool-bar i.icon-print,
#tool-bar a.print {
	display: none;
}
</style>
